import { WDD }             from './core/wdd.js';
import { injectSVGSprite } from './modules/injectSVGSprite.js';
import { buyButton }       from './modules/buyButton.js';
import { modelSwitch }     from './modules/modelSwitch.js';
import { opener }          from './modules/opener.js';
import { variants }        from './modules/variants.js';
import { prices }          from './modules/prices.js';

// Register module functions
WDD.injectSVGSprite = injectSVGSprite;
WDD.modelSwitch = modelSwitch;
WDD.opener = opener;
WDD.variants = variants;
WDD.prices = prices;
WDD.buyButton = buyButton;

WDD.init = function() {
    if (WDD.__initialized) return;
    WDD.__initialized = true;
    WDD.type = "bp"; // type of the page
    WDD.el = document.getElementById(WDD.type);

    // ------------- Building the page -------------
    Object.values(WDD).forEach(func => typeof func === 'function' && func());

    // ------------- Setting up basic data -------------
    WDD.data.mainNavigationUrl = "/api/navigation";
    WDD.data.isApp     = document.body.classList.contains("mobileapp");
    WDD.data.isMobile  = document.body.classList.contains("mobile");
    WDD.data.orderLink = WDD.data.isApp ? "alza://order1?addcode=" : "/order1.htm?addcode=";
    WDD.data.lang      = WDD.utils.getLanguage();
};

// Initializing WDD scripts
if (!WDD.__initialized) {
    if (document.readyState !== "loading") WDD.init();
    else document.addEventListener("DOMContentLoaded", WDD.init);
}
